/**
 * frontend-base App (L-009). widgetReplace of the shell layouts.
 * Slot IDs from openedx/frontend-base shell/header/app.tsx and
 * shell/footer/app.tsx (main, 2026-10-02). relatedId is the default widget
 * id. Verawood-pinned tag on the Learn image is unverified.
 *
 * condition.callback keeps instructor / gradebook routes on the default
 * header DesktopLayout (tokens only). /authoring leftover chrome is L-044
 * (not this site App). The footer REPLACE is unconditional
 * (L-038): frontend-base 1.0.1 DesktopFooterLayout hardcodes <PoweredBy>
 * (logos.openedx.org/open-edx-logo-tag.png + trademark text). BsgFooter
 * returns null on remaining staff paths. L-042 REMOVEs tutor-indigo
 * IndigoFooter (widget indigo_footer / custom_footer) on leftover
 * footer.v1 — that widget is a sibling of the desktop layout, not
 * PoweredBy.
 */
import { WidgetOperationTypes } from "@openedx/frontend-base";
import { BsgFooter } from "./BsgFooter.js";
import { BsgHeader } from "./BsgHeader.js";
import { BsgIdOwnsNotice } from "./BsgIdOwnsNotice.js";
import { isLearnerChrome } from "./isLearnerChrome.js";

const learnerOnly = { callback: () => isLearnerChrome() };

/** @type {import("@openedx/frontend-base").App} */
const app = {
  appId: "org.bsg.frontend.app.learnChrome",
  slots: [
    {
      slotId: "org.openedx.frontend.slot.header.desktop.v1",
      id: "org.bsg.frontend.widget.header.v1",
      op: WidgetOperationTypes.REPLACE,
      relatedId: "org.openedx.frontend.widget.header.desktopLayout.v1",
      component: BsgHeader,
      condition: learnerOnly,
    },
    {
      slotId: "org.openedx.frontend.slot.header.mobile.v1",
      id: "org.bsg.frontend.widget.header.mobileEmpty.v1",
      op: WidgetOperationTypes.REPLACE,
      relatedId: "org.openedx.frontend.widget.header.mobileLayout.v1",
      component: BsgHeader,
      condition: learnerOnly,
    },
    {
      slotId: "org.openedx.frontend.slot.footer.desktop.v1",
      id: "org.bsg.frontend.widget.footer.v1",
      op: WidgetOperationTypes.REPLACE,
      relatedId: "org.openedx.frontend.widget.footer.desktopLayout.v1",
      component: BsgFooter,
    },
    {
      slotId: "org.openedx.frontend.layout.footer.v1",
      op: WidgetOperationTypes.REMOVE,
      relatedId: "indigo_footer",
    },
    {
      slotId: "org.openedx.frontend.layout.footer.v1",
      op: WidgetOperationTypes.REMOVE,
      relatedId: "custom_footer",
    },
    {
      slotId: "org.openedx.frontend.account.additional_profile_fields.v1",
      id: "org.bsg.frontend.widget.account.bsgIdOwns.v1",
      op: WidgetOperationTypes.APPEND,
      component: BsgIdOwnsNotice,
    },
    {
      slotId: "org.openedx.frontend.slot.account.additionalProfileFields.v1",
      id: "org.bsg.frontend.widget.account.bsgIdOwnsSlot.v1",
      op: WidgetOperationTypes.APPEND,
      component: BsgIdOwnsNotice,
    },
  ],
};

export default app;